module.exports = __webpack_public_path__ + "img/couples-051.0804b1ad.jpg";